export const google = {
  clientId:
    "91297253397-0eu6455cgepsl04vdpj0ggpj5ddoiph3.apps.googleusercontent.com",
};

export const facebook = {
  appId: "583284253212809",
};
